export default "https://assets-v2.scaler.com/packs/files/exit-intent-placement-mobile.0edb9b.webp";